<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Pilates Chairs Flashcards by Lesley Logan</h2>
        <h3></h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="contrology_chairflashcards_teaser01@1x.jpg"
              src2="contrology_chairflashcards_teaser01@2x.jpg"
              alt="Product photo of Flashcard box"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_chairflashcards_teaser02@1x.jpg"
              src2="contrology_chairflashcards_teaser02@2x.jpg"
              alt="Photo of Flashcards deck"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_chairflashcards_teaser03@1x.jpg"
              src2="contrology_chairflashcards_teaser03@2x.jpg"
              alt="Photo of Flashcards deck"
            />
          </photo-grid>

          <cta-prod-button
            class="cta-button wide"
            link="wunda-chair"
            src="contrology-wundachair1@1x.jpg"
            src2="contrology-wundachair1@2x.jpg"
            alt="Product photo of Wunda Chair"
            productName="Contrology Wunda Chair"
          />

          <div class="content-wrapper">
            <section class="intro">
              <h2>Pilates Chairs Flashcards by Lesley Logan</h2>
              <h3></h3>
              <p>97 full-color flashcards to help you study classical Pilates Chair exercises. Learn the exercise setup, action and complementary exercises, as well as some prep exercises to help you feel the movements in your body. You will also explore exercises for the Mat and Reformer that pair with the Chairs exercise, and pointers to dive deeper into every movement. Scan the barcode on the front of each card to watch a video of the exercise.</p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
            />

            <section class="links">
              <icon-link
                url="support#returns"
                img="icon-guarantee.svg"
                alt="Guarantee icon"
                title="Learn more"
              >30-Day Money Back Guarantee</icon-link>
            </section>

            <cta-prod-button
              class="cta-button"
              link="wunda-chair"
              src="contrology-wundachair1@1x.jpg"
              src2="contrology-wundachair1@2x.jpg"
              alt="Product photo of Wunda Chair"
              productName="Contrology Wunda Chair"
            />

          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import CtaProdButton from "@/components/CtaProdButton.vue";

export default {
  name: "flashcards",

  metaInfo: {
    title: "Pilates Chairs Flashcards by Lesley Logan",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "97 full-color flashcards to help you study classical Pilates Chair exercises."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    CtaProdButton,
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      product: {
        label: "Select Product",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 47807247876289,
          partnumber: 18667,
          price: 89.99,
          name: "Pilates Chairs Flashcards",
          available: true
        }
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
